import { render, staticRenderFns } from "./ImageSlide.vue?vue&type=template&id=2644c528&"
import script from "./ImageSlide.vue?vue&type=script&lang=js&"
export * from "./ImageSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports